import Component from '@glimmer/component'
import { themeClasses } from 'teacher-ui-client/components/underline-tab/themes'
import type { ThemeKeys } from 'teacher-ui-client/utils/themes'

interface Signature {
  Element: HTMLButtonElement
  Args: {
    themeKey: ThemeKeys
    active?: boolean
  }
  Blocks: {
    default: []
  }
}

export class UnderlineTabButton extends Component<Signature> {
  get themeClasses() {
    return themeClasses(this.args.themeKey)
  }

  <template>
    <button
      type="button"
      role="link"
      class="{{if @active 'active'}}
        active-link:border-b-[3px] print:active-link:mx-auto print:active-link:block print:active-link:max-w-[50%] print:active-link:!border-black print:active-link:bg-transparent cursor-pointer border-b-2 bg-white p-2 text-center font-semibold hover:border-b-[3px] focus:border-b-[3px] print:hidden
        {{this.themeClasses}}"
      ...attributes
    >
      {{yield}}
    </button>
  </template>
}
